var map = {
	"./bootstrap_cronos.png": 45,
	"./bootstrap_dark.png": 46,
	"./bootstrap_light.png": 47,
	"./bootstrap_material.png": 48,
	"./bootstrap_metis.png": 49,
	"./bootstrap_sirius.png": 50,
	"./bootstrap_zeus.png": 51,
	"./bulma_cronos.png": 52,
	"./bulma_metis.png": 53,
	"./bulma_plain.png": 54,
	"./bulma_zeus.png": 55,
	"./material-ui_materialui.png": 56,
	"./material-ui_nereus.png": 57,
	"./tailwind_artemis.png": 58,
	"./tailwind_atis.png": 59,
	"./tailwind_bendis.png": 60,
	"./tailwind_metis.png": 61,
	"./tailwind_plain.png": 62,
	"./tailwind_shuffle.png": 63,
	"./tailwind_yofte.png": 64,
	"./tailwind_zeus.png": 65,
	"./tailwind_zospace.png": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;